import apiClient from '../clienteFebosAPI';

const RESOURCE = '/documentos';

export const clGetReferences = (febosId) => apiClient
  .get(`${RESOURCE}/${febosId}/referenciasdnt`,
    { operacionId: 'io.documents.references' });

export const signAttachment = (sign) => {
  const params = apiClient.queryParams(sign);
  return apiClient
    .post(`${RESOURCE}/firmar?${params}`,
      sign, { operacionId: 'sign.attachment' });
};

export const getDocumentToSign = (sign) => {
  const params = apiClient.queryParams(sign);
  return apiClient
    .put(`${RESOURCE}/firmar?${params}`,
      sign, { operacionId: 'get.document.to.sign' });
};
